import { Component, OnDestroy, OnInit, Input, ViewContainerRef, } from '@angular/core';
// import { CorporateMembers } from './../../api/corporate-members';
import { MysqlService } from './../../services/mysql.service';
import { SearchService,  } from './../../services/search.service';

import { Meta, Title } from '@angular/platform-browser';
import {NgxPaginationModule} from 'ngx-pagination'; // <-- import the module
// import { AuthService } from '../../auth/auth.service';

import { FormsModule } from '@angular/forms';
import { BrowserModule } from '@angular/platform-browser';
// import { FilterPipe } from './../../../filters/filter.pipe';


import {platformBrowserDynamic} from '@angular/platform-browser-dynamic';

import {ReactiveFormsModule, FormControl} from '@angular/forms';
import {Observable, map, debounceTime, distinctUntilChanged,switchMap, tap} from 'rxjs';

import { ActivatedRoute, Router } from '@angular/router';
import { DemoService } from './../../demo.service';
import { HotToastService } from '@ngneat/hot-toast';
import { GlobalFunctionsService } from './../../services/global-functions.service';



declare var jQuery:any;

@Component({
  selector: 'app-staff-dashboard',
  templateUrl: './staff-dashboard.component.html',
  styleUrls: ['./staff-dashboard.component.css']
})
export class StaffDashboardComponent implements OnInit {
  nav: any;
  body: HTMLBodyElement;
  currentUserVAR: any;
  sessionUserId: any;
  sessionUsername: any;
  sessionBrandId: any;
  sessionUserLevel: any;
  brand_id: any;

  public sparklineData:Array<any> = [34, 43, 43, 35, 44, 32, 44, 52];
  public sparklineData2:Array<any> = [32, 11, 25, 37, 41, 32, 34, 42];
  public sparklineOptions:any = {type: 'line', width: '100%', height: '50', lineColor: '#1ab394', fillColor: "transparent"};

  public peityType1:string = "bar";
  public peityType2:string = "line";
  public peityOptions1:any = { fill: ["#1ab394", "#d7d7d7"], width:100};
  public peityOptions2:any = { fill: ["#1ab394", "#d7d7d7"]};
  public peityOptions3:any = { fill: '#1ab394', stroke:'#169c81'};
  all_router_details: string;


  constructor(meta: Meta, title: Title ,
     private _mysqlService: MysqlService, public itunes: SearchService, public member: SearchService,
     private route: ActivatedRoute, private router: Router,
    public _demoService: DemoService,
    public toastr: HotToastService,
    vcr: ViewContainerRef,
    public gfunc: GlobalFunctionsService
     ) { 
      this.nav = document.querySelector('nav.navbar');
      this.body = document.querySelector('body');

// Set and Access login Session Variables
this.gfunc.setLoginSessionVars(); // set in a global function file
this.sessionUserId = this.gfunc.currentUserVAR.user_id;
this.sessionUsername = this.gfunc.currentUserVAR.username;
this.sessionBrandId = this.gfunc.currentUserVAR.brand_id;

// need to add this as routes does not work globally
this.all_router_details = this.router.url;
this.gfunc.current_base_route = this.router.url.substr(0, this.all_router_details.lastIndexOf('/'));
  
     }

  ngOnInit() { }

  public ngOnDestroy(): any {
    // this.nav.classList.remove("white-bg");
    // this.body.classList.remove('top-navigation');
   // this.body.className.remove(" skin-2");

  }






}
